// Loading states for CopilotBar component
export const COPILOT_BAR_LOADING_STATES = {
    IDLE: 'idle',
    LOADING: 'loading',
    COMPLETED: 'completed',
    RECORDING_ERROR: 'recording_error',
    PROCESSING_ERROR: 'processing_error',
};

// Regex patterns - Optimized for performance
export const CHART_REGEX = /\[fm_report=(['"])([^'"]*)\1\]/;
export const CHART_REGEX_GLOBAL = /\[fm_report=(['"])([^'"]*)\1\]/g;
export const DETAIL_REGEX = /\[fm_detail=(['"])([^'"]*)\1\]/;
export const DETAIL_REGEX_GLOBAL = /\[fm_detail=(['"])([^'"]*)\1\]/g;
export const TABLE_REGEX = /\[fm_table=(['"])([^'"]*)\1\]/;
export const TABLE_REGEX_GLOBAL = /\[fm_table=(['"])([^'"]*)\1\]/g;
export const MARKDOWN_BOLD_REGEX = /\*\*([^*]+)\*\*/g;
export const HTML_TAG_REGEX = /<[^>]+>/g;

// SVG Icons
export const SVG_DOWNLOAD = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#7D8A96" fill-rule="evenodd" d="M19 9h-4V3H9v6H5l7 7 7-7ZM5 18v2h14v-2H5Z" clip-rule="evenodd"/></svg>`;

// Stream identifiers
export const COPILOT_CHAT_STREAM_IDENTIFIERS = {
    detail: 'data-fm_detail',
    chart: 'data-fm_action_chart',
    table: 'data-fm_action_table',
    detailShort: 'fm_detail',
    chartShort: 'fm_action_chart',
    tableShort: 'fm_action_table',
};

// Chart defaults
export const CHART_DEFAULTS = {
    width: 533,
    height: 300,
    devicePixelRatio: 2.5,
    padding: 12,
    colorThreshold: 170,
    grayscaleWeights: [0.299, 0.587, 0.114],
};

// Input modes for CopilotBar
export const INPUT_MODE = {
    FILE: 'file',
    TEXT: 'text',
    URL: 'url',
};

// Feedback types for CopilotBar inline feedback
export const FEEDBACK_TYPES = {
    ERROR: 'error',
    HINT: 'hint',
    INFO: 'info',
    INTERACTIVE: 'interactive',
    WARNING: 'warning',
};

export const DEFAULT_INPUT_MODE = INPUT_MODE.TEXT;

// Placeholder keys for each input mode
export const INPUT_MODE_PLACEHOLDER_KEYS = {
    [INPUT_MODE.TEXT]: 'placeholder_copilot_bar_crud',
    [INPUT_MODE.FILE]: 'label_copilot_voicecrud_describe_information_to_extract_from_file',
    [INPUT_MODE.URL]: 'label_copilot_voicecrud_add_the_url_you_want_extract_information_from',
};
